/**
 * Question World Module - ImagePreview Component
 * Modal preview for explanation images
 */

import { useState } from 'react';
import { Image, Modal, Space } from 'antd';
import { bucket_url } from '../../helpers/constants';
import PdfPlaceholder from '../../assets/pdf_placeholder.png';

const ImagePreview = ({ question }) => {
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    const handlePreview = (imageUrl) => {
        setPreviewImage(imageUrl);
        setPreviewVisible(true);
    };

    return (
        <>
            <Space>
                {!!question?.questionId &&
                    question?.questionId?.explanationExt &&
                    question?.questionId?.explanationExt.map((item, index) => (
                        <Image
                            key={index}
                            preview={false}
                            placeholder
                            src={bucket_url + item}
                            width={'100%'}
                            style={{ objectFit: 'contain', cursor: 'pointer' }}
                            fallback={PdfPlaceholder}
                            onClick={() => handlePreview(bucket_url + item)}
                        />
                    ))}
            </Space>

            <Modal
                open={previewVisible}
                footer={null}
                onCancel={() => setPreviewVisible(false)}
                centered
            >
                <Image src={previewImage} width="100%" style={{ objectFit: 'contain' }} />
            </Modal>
        </>
    );
};

export default ImagePreview;

